import { render, staticRenderFns } from "./RemindPop.vue?vue&type=template&id=73818eaf&scoped=true"
import script from "./RemindPop.vue?vue&type=script&lang=js"
export * from "./RemindPop.vue?vue&type=script&lang=js"
import style0 from "./RemindPop.vue?vue&type=style&index=0&id=73818eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73818eaf",
  null
  
)

export default component.exports